export default __webpack_public_path__ + "static/media/portfolio4.08d7fcc7.jpg";